import { fromJS } from 'immutable';
import { actions } from 'react/api/actions/toastAlerts';
import { getToastIndex } from '../selectors/toastAlerts';

const initialState = fromJS({
  toasts: []
});

export default function (state = initialState, action) {
  switch (action.type) {
    case actions.addToast: {
      const { payload } = action;

      const toastIndex = getToastIndex(state, payload.id);

      if (toastIndex > -1) {
        return state.mergeIn(['toasts', toastIndex], fromJS(payload));
      }

      return state.updateIn(['toasts'],
        (toastsAlertsList) => toastsAlertsList.push(fromJS(payload)));
    }
    case actions.removeToast: {
      const { payload: { id } } = action;

      const toastIndex = getToastIndex(state, id);

      return toastIndex > -1
        ? state.removeIn(['toasts', toastIndex]) : state;
    }
    default:
      return state;
  }
}
